import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import { ApiService } from '../../../modules/common/services/api.service';
import { CookieService } from 'ngx-cookie-service';
import API from '../../../modules/common/services/api.config.json';
import * as _ from 'lodash';
import { SharedService } from '../../common/services/shared-service';
import { Observable, BehaviorSubject } from 'rxjs';
import { HeaderService } from 'app/modules/fuse/services/header-service';
import { environment } from 'environments/environment';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as GenericRestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { NotificationsService } from 'app/modules/common/services/notifications.service';
import { EmployeeService } from '../../employee/services/employee.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SMSVerifyResults } from 'app/modules/common/types/sms-verify-results.type';
import * as shajs from 'sha.js';
import * as CryptoJS from 'crypto-js';
import Utils from 'app/Utils';
import { utils } from 'xlsx';
import { Router } from '@angular/router';


@Injectable()

export class AuthService {
    private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    tokenArray = [];
    Request = {};
    isExpired = false;
    isNotVerified = false;
    isTelephoneNotAvailable = false;
    maximumAttempts = 3;
    invalidPwCount = 0;
    remainAttempts = 3;
    currentUserName = '';
    tempUserName = '';
    isLogInLock = false;
    isLogInFailed = false;
    public responseMassageLock = 0;
    subscription: any;

    get isLoggedIn(): Observable<any> {
        return this.loggedIn.asObservable();
    }

    constructor(
        private router: Router,
        private http: HttpClient,
        private apiService: ApiService,
        private cookieService: CookieService,
        private sharedService: SharedService,
        private employeeService: EmployeeService,
        public snackBar: MatSnackBar,
        private headerService: HeaderService,
        private notificationService: NotificationsService
    ) {
    }

    decryptData(data) {

        try {
          const bytes = CryptoJS.AES.decrypt(data, "abc123");
          if (bytes.toString()) {
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          }
          return data;
        } catch (e) {
          console.log(e);
        }
      }


    


    toLowerFirstLetter(obj: any): any {  
        if (Array.isArray(obj)) { 
               return obj.map(item => this.toLowerFirstLetter(item)); 
             } else if (obj !== null && typeof obj === 'object') { 
                   const newObj: any = {}; 
                      for (const key of Object.keys(obj)) {  
                            const newKey = key.charAt(0).toLowerCase() + key.slice(1); 
                                 newObj[newKey] = this.toLowerFirstLetter(obj[key]);
                                    }    return newObj;  } else {    return obj;  }
    }

    login(result: any, cookie: any): Promise<boolean> {
        this.isNotVerified = false;
        let isVerifyingPhone = false;
        return new Promise<boolean>((resolve, reject) => {
            this.loggedIn.next(true);
            let utf8Encode = new TextEncoder();
            

            this.apiService.post(API.auth.login, result, false, cookie).subscribe(data => {
                var response = data.body;
                if(response.result != null){
                    response.result.usuario = Utils.decrypt(response.result.usuario); //Desencriptamos el objeto usuario
                    response.result.usuario = JSON.parse(response.result.usuario); ///Lo convertimos a Json
                    response.result.usuario  = this.toLowerFirstLetter(response.result.usuario); //Al desencriptar, el json tiene en mayuscula la primera letra de cada propiedad, deberia ser minuscula
                }
                
                if (response.code === 0) {
                    if(response.result.twoFactorAuth == false || response.result.twoFactorAuth === false){
                        localStorage.setItem('permissionIds', Utils.encrypt(response.result.usuario.permissionIds.toString()));
                    }
                }
                const tokenArray = localStorage.getItem('tokenArray');

                if (tokenArray == null || tokenArray.length > 0) {
                    if (response != null) {
                        if (response.code === 0) {
                            if (response.message == null) {
                                localStorage.setItem('currentUser', Utils.encrypt(JSON.stringify(response.result)));
                                // const currentUser = response.result;
                                const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));
                                // Reset Attemp Counts
                                localStorage.removeItem('InvalidAttempts');
                                localStorage.removeItem('AttempUserName');
                                this.remainAttempts = 3;

                                this.notificationService.startConnection();

                                if (currentUser.medicoId) {
                                    this.router.navigate(['/doctor']);
                                } else if (currentUser.coordinador) {
                                    this.router.navigate(['/coordinators-main']);
                                } else {
                                    this.router.navigate(['/admin']);
                                }

                            } else if (response.message === 'NavigateVerifyCodeView') {

                                this.tokenArray.forEach(element => {
                                    localStorage.setItem(element.Header, element.Value);
                                });

                                if (response.result.usuario) {
                                    localStorage.setItem('currentUser', Utils.encrypt(JSON.stringify(response.result.usuario)));
                                }else{
                                    localStorage.setItem('currentUser', Utils.encrypt(JSON.stringify(response.result)));
                                }

                                if (response.result.usuario.telefono !== null && response.result.usuario.telefono !== '') {
                                    isVerifyingPhone = true;
                                    
                                        if (response.code === 0) {

                                            localStorage.removeItem('tokenArray');
                                            this.tokenArray = [];

                                            const messageTokenName = String('messagetoken_' + response.result.usuario.abreviacion).toLowerCase();
                                            const messageTokenValue = data.headers.get(messageTokenName);
                                            if (messageTokenValue !== null) {
                                                this.tokenArray.push({
                                                    Header: messageTokenName,
                                                    Value: messageTokenValue
                                                });
                                            }

                                            const expireTokenName = String('expirecheck_' + response.result.usuario.abreviacion).toLowerCase();
                                            const expireTokenValue = data.headers.get(expireTokenName);
                                            if (expireTokenValue !== null) {
                                                this.tokenArray.push({
                                                    Header: expireTokenName,
                                                    Value: expireTokenValue
                                                });
                                            }

                                            const verifiedTokenName = String('tokenverified_' + response.result.usuario.abreviacion).toLowerCase();
                                            const verifiedTokenValue = data.headers.get(verifiedTokenName);
                                            this.tokenArray.push({
                                                Header: verifiedTokenName,
                                                Value: verifiedTokenValue
                                            });

                                            localStorage.setItem('tokenArray', JSON.stringify(this.tokenArray));

                                            this.cookieService.set('SMSVarifyCode', Utils.encrypt(response.result.encText));
                                            localStorage.setItem('SMSVarifyCode', Utils.encrypt(response.result.encText));

                                            this.sharedService.LoggedUser = response.result.usuario;

                                            localStorage.removeItem('InvalidAttempts');
                                            localStorage.removeItem('AttempUserName');
                                            this.remainAttempts = 3;

                                            const currentUser = response.result.usuario;

                                            if (response.result.twoFactorAuth) {
                                                this.router.navigate(['/VerifyCode']);
                                            } else {
                                                // Process when valid verification code is entered
                                                localStorage.setItem('IsUserVerified', 'true');

                                                this.notificationService.startConnection();

                                                if (currentUser.medicoId) {
                                                    this.router.navigate(['/doctor']);
                                                } else if (currentUser.coordinador) {
                                                    this.router.navigate(['/coordinators-main']);
                                                } else {
                                                    this.router.navigate(['/admin']);
                                                }
                                            }
                                        } else {
                                            this.sharedService.ShowSnackBar('hubo un error al generar el código de verificación, '
                                                + 'asegúrese de que el usuario tenga un número de teléfono válido');
                                        }
                                        resolve(true);
                                } else {
                                    this.sharedService.ShowSnackBar('No se proporciona teléfono');
                                }

                            } else if (response.message === 'Expired') {
                                localStorage.clear();
                                this.isExpired = true;
                            } else if (response.message === 'DeleteMessageToken') {
                                localStorage.clear();
                                this.isNotVerified = true;
                            } else if (response.message === 'NavigateTelephonoView') {
                                this.isTelephoneNotAvailable = true;
                                localStorage.clear();
                            }
                            if (!isVerifyingPhone)
                                resolve(true);
                        } else if (response.code === 3) {

                            if (response.message === 'PasswordExpired') {
                                localStorage.setItem('userID', JSON.stringify(response.result.usuarioId));
                                this.router.navigate(['/ChangePassword']);
                            } else if (response.message === 'DeleteMessageToken') {
                                localStorage.clear();
                                this.isNotVerified = true;
                            }
                            resolve(true);
                        } else if (response.code === 1) {

                            if (response.message === 'Nombre de usuario o contraseña incorrecta') {
                                this.sharedService.ShowSnackBar(response.message);

                                this.countFailedLogins().then(
                                    res => {
                                        this.isLogInFailed = true;
                                        this.remainAttempts = this.maximumAttempts - this.invalidPwCount;
                                        if (this.invalidPwCount === this.maximumAttempts) {
                                            this.isLogInLock = true;
                                            let url = `${constant.HOME_URL}${API.auth.lock_User}`;
                                            url = url.replace('{UserName}', this.tempUserName);
                                            this.http.post(url, null).subscribe(resData => {
                                                const tempArray = [];
                                                tempArray.push(resData);
                                                if (tempArray[0].message === '') {
                                                    this.responseMassageLock = 1;
                                                }
                                                if (tempArray[0].message === 'User Not Found') {
                                                    this.responseMassageLock = 2;
                                                }

                                                // Remove Invalid Attempts after User is Locked
                                                localStorage.removeItem('InvalidAttempts');
                                                localStorage.removeItem('AttempUserName');

                                            }, err => {
                                                console.error(err);
                                            });
                                        }
                                    }
                                );
                            } else if (response.message === 'Account locked') {
                                this.responseMassageLock = 4;
                                this.sharedService.ShowSnackBar('Tu cuenta esta bloqueada');
                            } else {
                                this.sharedService.ShowSnackBar('Hubo un error, por favor intente de nuevo');
                            }
                        }
                    }

                } else {
                    this.tokenArray = JSON.parse(tokenArray);
                }
                if (!isVerifyingPhone)
                    resolve(true);
            }, err => {
                reject(err);
            });
        });
    }

    countFailedLogins(): any {
        this.invalidPwCount = Number(localStorage.getItem('InvalidAttempts'));
        return new Promise(resolve => {
            if (this.invalidPwCount === 0) {
                this.tempUserName = this.currentUserName;
                this.invalidPwCount++;
                localStorage.setItem('InvalidAttempts', String(this.invalidPwCount));
                localStorage.setItem('AttempUserName', this.currentUserName);
                resolve(null);
            } else {
                this.tempUserName = localStorage.getItem('AttempUserName');
                if (this.tempUserName === this.currentUserName) {
                    this.invalidPwCount++;
                } else {
                    this.invalidPwCount = 0;
                }
                localStorage.setItem('InvalidAttempts', String(this.invalidPwCount));
                resolve(null);
            }
        });
    }

    logout(): void {
        // remove user from local storage to log user out
        this.router.navigate(['/']);
        localStorage.removeItem('currentUser');
        localStorage.removeItem('permissionIds');
        localStorage.removeItem('Empresa');
        localStorage.removeItem('SelectedCompanyName');
        localStorage.removeItem('companiesForTreeView');
        // This is checked and API details are called before login
        localStorage.removeItem('EmplooyeeID');
        localStorage.removeItem('SMSVarifyCode');
        this.headerService.textsearch = '';
    }

    UpdatePassword(Credentials): Observable<any> {
        const url = `${constant.HOME_URL}${API.auth.update_password}`;
        return this.http.put(url, Credentials);
    }

    // Reset password
    CreatePassword(reset): Observable<any> {
        const url = `${constant.HOME_URL}${API.auth.create_password}`;
        return this.http.post(url, reset);
    }

    CheckTwoFactorAuthentication(abbreviation: string): Observable<any> {
        const input = { Abreviacion: abbreviation };
        const url = `${API.auth.SendVarifySMS}`;
        return this.apiService.post(url, input, false);
    }

    VerifySmsCode(rCode: string, code: string, user: string, pass: string): Observable<RestResponse> {
        const input = { ResponseCode: rCode, Code: code, User: user, Pass: pass };
        const url = `${API.auth.VerifySmsCode}`;
        return this.apiService.post(url, input, true);
    }
}
